import React, { Fragment } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import parse from 'html-react-parser';
import ModalHeader from '@common-components/headers/ModalHeader';
import { entityModalTypes } from '@constants/entity/modals/entityModalTypes';
import  { TRANSFER_MODAL_MSG } from '@constants/entity/entityTranferBOBConfig';
import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';
const TransferPopupModal = props => {    
    const {
        modal:{
            modalData,
            modalType
        },
        modalHeaderProps,
        hideCloseIcon,
        userRole,
        actions: {
            hideModal,
            onHide
        }
    } = props;    
    const { AGENCY_MANAGER, BROKER_ADMIN, ASSISTERENROLLMENTENTITY, ASSISTERENROLLMENTENTITYADMIN, ADMIN } = ALL_USER_ROLES;
    const intlApi = useIntl();

    const handleCloseModal = () => {        
        if(onHide){
            onHide();
        }        
        hideModal();     
    };

    const getClasses = () => {
        switch(modalType){
            case entityModalTypes.TRANSFER_SUCCESS_MODAL : 
                return 'usa-alert usa-alert--success gi-alert gi-alert__success';
            case entityModalTypes.TRANSFER_PARTIAL_SUCCESS_MODAL:
                return 'usa-alert usa-alert--warning gi-alert gi-alert__warning';
            case entityModalTypes.TRANSFER_VALIDATION_ERROR_MODAL :
            case entityModalTypes.TRANSFER_FAILURE_MODAL:
            case entityModalTypes.TRANSFER_ERROR_MODAL: 
                return 'usa-alert usa-alert--error gi-alert gi-alert__error';
            default:
                return '';
        }
    };

    const getModalMessage = () => {
        if ([AGENCY_MANAGER, BROKER_ADMIN].includes(userRole)) {
            if (modalType === entityModalTypes.TRANSFER_FAILURE_MODAL) {
                if (userRole === BROKER_ADMIN) {
                    return <FormattedMessage id='bob.transfer.agency.admin.failure.msg' values={modalData} />;
                } else if (userRole === AGENCY_MANAGER) {
                    return <FormattedMessage id='bob.transfer.agency.manager.failure.msg' values={modalData} />;
                }
                return parse(intlApi.formatMessage({ id: TRANSFER_MODAL_MSG.Agency[modalType] }, { ...modalData }));
            }
            return parse(intlApi.formatMessage({ id: TRANSFER_MODAL_MSG.Agency[modalType] }, { ...modalData }));
        } else if ([ASSISTERENROLLMENTENTITY, ASSISTERENROLLMENTENTITYADMIN, ADMIN].includes(userRole)) {
            return parse(intlApi.formatMessage({ id: TRANSFER_MODAL_MSG[userRole][modalType] }, { ...modalData }));
        }
    };

    return (
        <Fragment>
            <div className="gi-modal__header__head">
                <ModalHeader { ...{ ...modalHeaderProps }} hideCloseIcon={hideCloseIcon} hideModalCallback={handleCloseModal} />
            </div>
            <div className="gi-modal__body">
                <div className={getClasses()}>
                    {getModalMessage()}
                </div>
            </div>
            <div id='transfer-modal__footer' className="gi-modal__controls">
                {
                    modalType !== entityModalTypes.TRANSFER_IN_PROGRESS_MODAL ? <button onClick={handleCloseModal}
                        className="usa-button gi-button gi-button__primary">
                        <FormattedMessage id='button.close' />
                    </button> : null
                }
                
            </div>
        </Fragment>
    );
};

export default TransferPopupModal;
